import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { useTheme } from '@mui/material';
import { Container } from './ChartTooltip.styles';
interface ChartTooltipProps {
  title: React.ReactNode;
  items: {
    label: string;
    value: React.ReactNode;
    valueFormat?: (value: React.ReactNode) => string;
  }[];
  anchor?: 'right' | 'left';
}

export const ChartTooltip: React.FC<ChartTooltipProps> = ({
  title,
  items,
  anchor,
}) => {
  const theme = useTheme();

  return (
    <Container
      sx={{
        ...(anchor === 'left' && { transform: 'translate(49%, 0)' }),
        ...(anchor === 'right' && { transform: 'translate(-49%, 0)' }),
      }}
    >
      <Text
        variant='body'
        fontWeight='fontWeightSemiBold'
        sx={{
          color: theme.palette.grey.A100,
        }}
      >
        {title}
      </Text>
      <Flex flexDirection='column' marginTop={title ? 4 : 0}>
        {items.map((x, i) => (
          <Flex
            key={x.label}
            flex={1}
            mb={i < items.length - 1 ? 6 : 0}
            justifyContent='space-between'
          >
            <Text variant='body' fontWeight='fontWeightSemiBold' sx={{ mr: 6 }}>
              {x.label}
            </Text>
            <Text
              variant='body'
              fontWeight='fontWeightSemiBold'
              sx={{
                color: theme.palette.primary.main,
              }}
            >
              {x.valueFormat ? x.valueFormat(x.value) : x.value}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Container>
  );
};
